import { formatIeComplaintDateTime } from "./ieComplaintUtils";

const HISTORY_COLUMNS = [
  "S.No",
  "Action Taken By",
  "Status",
  "Action Remarks",
  "Assigned On",
  "Action Taken On",
];

const statusBadgeStyles = {
  Open: { color: "#9a6700", backgroundColor: "#fff3cd" },
  Pending: { color: "#0d6efd", backgroundColor: "#cfe2ff" },
  Closed: { color: "#0f5132", backgroundColor: "#d1e7dd" },
};

const IeComplaintActionHistoryTable = ({
  history = [],
  isLoading = false,
  subThStyle,
  subTdStyle,
}) => {
  if (isLoading) {
    return (
      <div style={{ padding: "8px 0", fontSize: 14, color: "#6B7280" }}>
        Loading action history...
      </div>
    );
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <table
        style={{
          width: "100%",
          maxWidth: 960,
          borderCollapse: "collapse",
          textAlign: "left",
          fontSize: "14px",
        }}
      >
        <thead>
          <tr>
            {HISTORY_COLUMNS.map((col) => (
              <th key={col} style={subThStyle}>
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {!history?.length ? (
            <tr>
              <td colSpan={HISTORY_COLUMNS.length} style={{ ...subTdStyle, textAlign: "center" }}>
                No action history available.
              </td>
            </tr>
          ) : (
            history.map((item, index) => (
            <tr key={`${item.sNo ?? index}-${item.actionTakenOn}`}>
              <td style={subTdStyle}>{item.sNo ?? index + 1}</td>
              <td style={subTdStyle}>{item.actionTakenBy || "N/A"}</td>
              <td style={subTdStyle}>
                <span
                  style={{
                    ...(statusBadgeStyles[item.status] || statusBadgeStyles.Open),
                    padding: "4px 10px",
                    borderRadius: 4,
                    display: "inline-block",
                    minWidth: 72,
                  }}
                >
                  {item.status || "N/A"}
                </span>
              </td>
              <td style={subTdStyle}>{item.actionRemarks || "N/A"}</td>
              <td style={subTdStyle}>{formatIeComplaintDateTime(item.assignedOn)}</td>
              <td style={subTdStyle}>{formatIeComplaintDateTime(item.actionTakenOn)}</td>
            </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default IeComplaintActionHistoryTable;
